module.exports = __webpack_public_path__ + "img/cors.147a2d21.jpg";